import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function LaMalagueta() {
  return <NeighborhoodPageContent slug="la-malagueta" />;
}